import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { TRANSACCIONES_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function TransaccionesPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${TRANSACCIONES_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
